import { loadJsonFileIntoSessionStorage } from '../../tools/helpers';

class ContentHubShowStories {

  constructor(options = {}) {
    this.element = options.element;
    this.LARGE_TEASER_CONTAINER = document.getElementById('large-teaser-container');
    this.HTML_STORIES = document.getElementById('grid_html_stories');
    this.GRID_TEMPLATE = 'grid-template';
    this.GRID_TEMPLATE_NEXT = 'grid-template-next';
    this.GRID_STORIES = document.getElementById('grid_stories');
    this.STORY_TEMPLATE = document.getElementById('story-template');
    this.SELECT_ALL_ID = 'select-all';
    this.topics = []; // Initial leeres Topics-Array
    this.currentIndex = 0;
    this.filterChanged = false;
  }

  init() {
    this.element.addEventListener('click', () => {
      this.showStories();
    });
    this.setupCategoryButtons();
    this.observeFilterCollectionChanges();
  }

  async showStories() {
    // check if json is not in session storage and then load it from the URL
    if (!sessionStorage.getItem('storyJson')) {
      await this.loadStoriesFromJson();
    }

    // load json data from session storage
    const dataFromSessionStorage = sessionStorage.getItem('storyJson');
    if (dataFromSessionStorage != null) {
      const hasMoreStories = this.createStoryBoxes(JSON.parse(dataFromSessionStorage), this.currentIndex);


      if (hasMoreStories) {
        this.currentIndex += 6;
        this.element.style.display = ''; // Zeige den More Button an, wenn es mehr Stories gibt
      } else {
        this.element.style.display = 'none'; // Verberge den More Button, wenn keine weiteren Stories vorhanden sind
      }
    }
  }


  async loadStoriesFromJson() {
    await loadJsonFileIntoSessionStorage(this.GRID_STORIES.getAttribute('data-stories-json'), 'storyJson');
  }

  // beobachten ob es bei dem Filterbuttons Änderungen gibt
  observeFilterCollectionChanges() {
    const filterCollection = document.querySelector('.filtercollection');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          this.filterChanged = true;
        }
      });
      if (this.filterChanged) {
        this.handleFilterChange();
      }
    });

    observer.observe(filterCollection, {
      attributes: true,
      subtree: true, // Beobachtet Änderungen an den Kind-Elementen
    });
  }

  handleFilterChange() {
    this.setupCategoryButtons(); // Aktualisiere das topics-Array
    this.currentIndex = 0;
    this.LARGE_TEASER_CONTAINER.innerHTML = '';

    if (this.topics.includes(this.SELECT_ALL_ID)) {
      this.HTML_STORIES.style.display = 'block';
      this.element.style.display = 'block'; // Zeige den "Mehr anzeigen"-Button
    } else {
      this.HTML_STORIES.style.display = 'none';
      this.showStories(); // Lade und zeige die gefilterten Stories
    }

    this.filterChanged = false; // Setze filterChanged zurück
  }

  // sammel alle topics aus den Filterbuttons
  // all topics uses the id instead of the label
  setupCategoryButtons() {
    const categoryButtons = document.querySelectorAll('.filtercollection .category-filter');
    this.topics = Array.from(categoryButtons)
      .filter(button => button.classList.contains('isActive'))
      .map(button => (button.getAttribute('data-id') === this.SELECT_ALL_ID ? button.getAttribute('data-id') : button.getAttribute('data-label')));
  }

  createStoryBoxes(data, startIndex) {
    const stories = this.filterStories(data);
    const gridTemplate = this.getGridTemplate(startIndex);

    const gridClone = document.importNode(gridTemplate.content, true);
    this.LARGE_TEASER_CONTAINER.appendChild(gridClone);
    const cardPlaces = this.LARGE_TEASER_CONTAINER.lastElementChild.querySelectorAll('.story');

    let displayedStories = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = startIndex; i < startIndex + 6 && i < stories.length; i++) {
      const story = stories[i];
      const currentCardPlace = cardPlaces[displayedStories];
      const bigStoryKeys = data.resolutions['big-story'];
      const smallStoryKeys = data.resolutions['small-story'];

      this.fillCardWithContent(currentCardPlace, story, i, bigStoryKeys, smallStoryKeys);
      // eslint-disable-next-line no-plusplus
      displayedStories++;
    }

    return stories.length > startIndex + displayedStories;
  }

  filterStories(data) {
    if (this.topics.length > 0 && !this.topics.includes(this.SELECT_ALL_ID)) {
      return data.stories.filter(story => story.topic.some(topic => this.topics.includes(topic)));
    }

    // only remove the initial html elements when no filter is selected
    const htmlStories = data['html-stories'];
    return data.stories.filter(story => !htmlStories.includes(story.id));
  }

  getGridTemplate(startIndex) {
    let gridTemplateId = (Math.floor(startIndex / 6) % 2 === 0) ? this.GRID_TEMPLATE : this.GRID_TEMPLATE_NEXT;

    if (this.filterChanged && !this.topics.includes(this.SELECT_ALL_ID)) {
      gridTemplateId = (Math.floor(startIndex / 6) % 2 === 0) ? this.GRID_TEMPLATE_NEXT : this.GRID_TEMPLATE;
    }

    return document.getElementById(gridTemplateId);
  }


  fillCardWithContent(cardPlace, story, i, bigStoryKeys, smallStoryKeys) {
    const storyTemplate = this.STORY_TEMPLATE.content;
    const storyClone = document.importNode(storyTemplate, true);

    storyClone.querySelector('a').href = story.link;
    if (story.link_target_current_window === false) {
      storyClone.querySelector('a').target = '_blank';
    }

    storyClone.querySelector('.card__headline').textContent = story.headline;
    storyClone.querySelector('.card__subline').textContent = story.subline;
    storyClone.querySelector('.card__text').textContent = story.text;

    const mediaQueries = [
      '(max-width: 320px)', '(max-width: 479px)', '(max-width: 767px)',
      '(max-width: 991px)', '(max-width: 1199px)', '(max-width: 1500px)',
      '(max-width: 10000px)',
    ];

    const pictureElement = storyClone.querySelector('picture');
    const imageKeys = cardPlace.classList.contains('big') ? bigStoryKeys : smallStoryKeys;
    imageKeys.forEach((key, index) => {
      if (story.image[key]) {
        const source = document.createElement('source');
        source.srcset = story.image[key];
        source.media = mediaQueries[index % mediaQueries.length];
        pictureElement.appendChild(source);
      }
    });

    const img = document.createElement('img');
    img.src = story.image['614x512'] || '';
    img.loading = 'lazy';
    img.alt = story.image_alt || '';
    pictureElement.appendChild(img);

    const topicCategory = storyClone.querySelector('.topic-category');
    const topicCategoryMobil = storyClone.querySelector('.topic-category.mobil');
    [topicCategory, topicCategoryMobil].forEach((categoryElement) => {
      if (categoryElement) {
        story.topic.forEach((topic) => {
          // eslint-disable-next-line no-param-reassign
          categoryElement.innerHTML += `<span>${topic}</span>`;
        });
      }
    });

    cardPlace.appendChild(storyClone);
  }
}

export default ContentHubShowStories;
